import { shortenAddress } from "@/utils/utils.js";

/** 列表筛选参数：与接口文档一致 */
export const ADMIN_LIST_STATUS_UNSHIPPED = "1";
export const ADMIN_LIST_STATUS_SHIPPED = "2";

function pad2(n) {
  return String(n).padStart(2, "0");
}

export function formatOrderCreated(ts) {
  const sec = Number(ts);
  if (!Number.isFinite(sec) || sec <= 0) return "—";
  const d = new Date(sec * 1000);
  return `${d.getFullYear()}.${pad2(d.getMonth() + 1)}.${pad2(d.getDate())} ${pad2(d.getHours())}:${pad2(d.getMinutes())}`;
}

/**
 * 映射为发货中心列表行（仅包含原 UI 展示的字段）
 * @param {object} raw 接口 data 单项
 */
export function mapAdminOrderRow(raw) {
  const wallet = String(raw.wallet || "");
  return {
    id: raw.id,
    wallet,
    userDisplay: shortenAddress(wallet) || wallet || "—",
    time: formatOrderCreated(raw.created),
    address: String(raw.address || ""),
    quantity: Number(raw.number) || 0,
    trackingInput: "",
    trackingNumber: String(raw.waybill ?? ""),
  };
}
